export const LIST = "GAME_CATEGORY_LIST";
export const DROPDOWN = "GAME_CATEGORY_DROPDOWN";
export const UPDATE_STATUS = "GAME_CATEGORY_UPDATE_STATUS";
export const EDIT_GAME_CATEGORY = "GAME_CATEGORY_EDIT";
export const UPDATE_GAME_CATEGORY = "GAME_CATEGORY_UPDATE";

